module.exports = __webpack_public_path__ + "static/media/1990.2c73219f.jpeg";